<template>
  <v-row dense>
    <v-col cols="12">
      <v-autocomplete
        v-model="form.related_id"
        :label="`${$t('RELATED_COMPANIES.ITEM')} *`"
        :items="companies"
        :loading="!!!companies"
        :item-text="item => item.id + '. ' + item.name"
        item-value="id"
        :rules="getRulesByName('related_id')"
        :readonly="readonly"
        :disabled="isEditAction"
        :error-messages="errors.related_id"
        @input="updateValue('related_id', $event)"
      />
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        v-model="form.relationship_id"
        :label="`${$t('RELATIONS.RELATIONSHIP')} *`"
        :items="relationships"
        :loading="!!!relationships"
        item-value="id"
        item-text="name"
        :rules="getRulesByName('relationship_id')"
        :readonly="readonly"
        :error-messages="errors.relationship_id"
        @input="updateValue('relationship_id', $event)"
      />
    </v-col>
    <v-col cols="12">
      <v-switch v-model="form.key" :label="$t('RELATIONS.KEY')"></v-switch>
    </v-col>
    <v-col cols="12">
      <v-textarea
        v-model="form.notes"
        :label="$t('RELATIONS.NOTES')"
        :rules="getRulesByName('notes')"
        :readonly="readonly"
        counter="80"
        outlined
        :error-messages="errors.notes"
        @input="updateValue('notes', $event)"
      />
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        v-model="form.priority"
        :label="`${$t('RELATIONS.PRIORITY')} *`"
        :items="prioritiesList"
        item-value="id"
        item-text="title"
        :rules="getRulesByName('priority')"
        :readonly="readonly"
        :error-messages="errors.priority"
        @input="updateValue('priority', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import {
  requiredSelectNotArray,
  textDescription80
} from '@/modules/_global/variables/rules.js';
import formEditable, { EDIT } from '@/modules/_global/mixins/form-editable';
import { RELATED_COMPANY } from '@/modules/companies/common/companyTypes';
import { mapActions } from 'vuex';
import priority from '@/modules/relations/components/mixins/priority';

export default {
  name: 'RelatedCompanyForm',

  mixins: [formEditable, priority],

  data: () => ({
    form: {
      key: false
    },
    rules: {
      related_id: requiredSelectNotArray,
      priority: requiredSelectNotArray,
      relationship_id: requiredSelectNotArray,
      notes: textDescription80
    },

    companies: [],
    relationships: []
  }),

  computed: {
    isEditAction() {
      return this.action === EDIT;
    }
  },

  created() {
    this.refreshData();
  },

  methods: {
    ...mapActions('company', ['retrieveCompaniesByType']),
    ...mapActions('relation', ['retrieveRelationshipsWithCompany']),

    getDataCompanies() {
      this.retrieveCompaniesByType(RELATED_COMPANY).then(({ data }) => {
        this.companies = data;
      });
    },

    getDataRelationships() {
      this.retrieveRelationshipsWithCompany().then(({ data }) => {
        this.relationships = data;
      });
    },

    refreshData() {
      this.getDataCompanies();
      this.getDataRelationships();
    }
  }
};
</script>

<style scoped></style>
